import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store";
import { v4 as uuidv4 } from 'uuid';

function prepareDataRequest(data) {
  return {
    RequestCorrelationId: uuidv4(),
    Data: data
  };
}

function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}

const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (!response.data)
      if (response.data.indexOf("Unauthorized") > -1) {
        router.push("/logout");
      }
    return response;
  },
  (error) => {
    return { data: error.message };
  }
);

function GetCommSchedule(year, month) {
  return client.post("CommSchedule/GetCommSchedule", prepareRequest({
    Year: year,
    Month: month
  }));
}

function CommScheduleClone() {
  return client.post("CommSchedule/CommScheduleClone", prepareRequest({}));
}

function CreateCommSchedule(item) {
  return client.post("CommSchedule/CreateCommSchedule", prepareDataRequest(item));
}

function UpdateCommSchedule(item) {
  return client.post("CommSchedule/UpdateCommSchedule", prepareDataRequest(item));
}

function DeleteCommSchedule(item) {
  return client.post("CommSchedule/DeleteCommSchedule", prepareDataRequest(item));
}

export {
  GetCommSchedule,
  CommScheduleClone,
  CreateCommSchedule,
  UpdateCommSchedule,
  DeleteCommSchedule
};